import React from "react";
import { CalendarControl } from "./controls/CalendarControl";
import { SelectBoxControl } from "./controls/SelectBoxControl";
import { RadioButtonsControl } from "./controls/RadioButtonsControl";
import { TextBoxControl } from "./controls/TextBoxControl";
import { DropDownListControl } from "./controls/DropDownListControl";
import { InternationalPhoneControl } from "./controls/InternationalPhoneControl";
import { EmailinputControl } from "./controls/EmailinputControl";
import { HeadingLabelControl } from "./controls/HeadingLabelControl";
import { ConsentAgreement } from "./controls/ConsentAgreement";
import { ValidationErrorsHtml } from "./FormValidation";
import { FormSummary } from "./summary/SummaryControl";
import { AdresZoeker } from "./features/AdresZoeker";
import { CitySearcherControl } from "./controls/CitySearcherControl";
import { CompanySearcherControl } from "./controls/CompanySearcherControl";
import { CompanySearcher } from "./features/CompanySearcher";
import { getResourceString } from "./../../kentico/resource-strings";
import { LabelControl } from "./controls/LabelControl";
import { TipBlockControl } from "./controls/TipBlockControl";
import { CheckBoxControl } from "./controls/CheckBoxControl";
import { ButtonControl } from "./controls/ButtonControl";
import { IncomeRelationSearcher } from "./features/IncomeRelationSearcher";

export const GetComponent = ({field, formDataEntry, errors, handleChange, handleBlur, formData, formDefinition, navigateToStep, formSummaryData} : ControlParameters) : JSX.Element => {
  
  if(field.settings.IsHiddenField == "True") {
    return null;
  }

  if(field.settings.PicklistMode && field.settings.PicklistMode === 'custompicklist') {
    if(field.settings.PicklistTemplate === 'bedrijvenzoeker') {
      if(field["@column"].endsWith('Naam')) {
        return <CompanySearcherControl
          key={field["@guid"]} 
          field={field} 
          handleChange={handleChange} 
          handleBlur={handleBlur} 
          city={formData[field["@column"].replace('Naam', 'Plaats')] ? formData[field["@column"].replace('Naam', 'Plaats')].value : ""} 
          formDataEntry={formDataEntry} 
          errors={errors} />;
      }
      else if(field["@column"].endsWith('Plaats')) {
        return <CitySearcherControl
          key={field["@guid"]} 
          field={field} 
          handleChange={handleChange} 
          handleBlur={handleBlur} 
          formDataEntry={formDataEntry} 
          errors={errors} />;
      }
    }

    if(field.settings.PicklistTemplate === 'incomeRelationSearcher') {
      if(field["@column"] === 'BedrijfsNaam') {
        return <CompanySearcherControl
          key={field["@guid"]} 
          field={field} 
          handleChange={handleChange} 
          handleBlur={handleBlur} 
          city={formData['BedrijfWoonplaats'] ? formData['BedrijfWoonplaats'].value : ""} 
          formDataEntry={formDataEntry} 
          errors={errors} />;
      }
      else if(field["@column"] === 'BedrijfWoonplaats') {
        return <CitySearcherControl
          key={field["@guid"]} 
          field={field} 
          handleChange={handleChange} 
          handleBlur={handleBlur} 
          formDataEntry={formDataEntry} 
          errors={errors} />;
      }
    }
  }

  switch (field.settings.componentidentifier) {
    case 'CalendarControl':
      return <CalendarControl field={field} handleChange={handleChange} handleBlur={handleBlur} formDataEntry={formDataEntry} errors={errors} />;
    case 'RadioButtonsControl':
      switch(field.properties.inputcontrolstyle) {
        case 'select-box':
          return <SelectBoxControl field={field} handleChange={handleChange} handleBlur={handleBlur} formDataEntry={formDataEntry} errors={errors} />;
        default:
          return <RadioButtonsControl field={field} handleChange={handleChange} handleBlur={handleBlur} formDataEntry={formDataEntry} errors={errors} />;
      }
    case 'TipBlock':
      return <TipBlockControl field={field} />;
    case 'TextBoxControl':
      return <TextBoxControl field={field} handleChange={handleChange} handleBlur={handleBlur} formDataEntry={formDataEntry} errors={errors} />;
    case 'InitialsInputField':
      return <TextBoxControl field={field} handleChange={handleChange} handleBlur={handleBlur} formDataEntry={formDataEntry} errors={errors} />;
    case 'DropDownListControl':
      return <DropDownListControl field={field} handleChange={handleChange} handleBlur={handleBlur} formDataEntry={formDataEntry} errors={errors} />;
    case 'internationalphone':
      return <InternationalPhoneControl field={field} handleChange={handleChange} handleBlur={handleBlur} formDataEntry={formDataEntry} errors={errors} />;
    case 'emailinput':
      return <EmailinputControl field={field} handleChange={handleChange} handleBlur={handleBlur} formDataEntry={formDataEntry} errors={errors} />;
    case 'FormFieldGroup':
      return <HeadingLabelControl field={field} />;
    case 'LabelControl':
      return <LabelControl field={field} formDataEntry={formDataEntry} />;
    case 'CheckBoxControl':
      return <CheckBoxControl field={field} handleChange={handleChange} formDataEntry={formDataEntry} errors={errors} />;
    case 'ConsentAgreement':
      return <ConsentAgreement field={field} handleChange={handleChange} formDataEntry={formDataEntry} errors={errors} />;
    case 'GridControl':
      return <FormSummary formSummaryData={formSummaryData} formData={formData} formFields={formDefinition.form.field} navigateToStep={navigateToStep} />;
    case 'ButtonControl':
      return <ButtonControl field={field} />;
    default:
      return null;
  }
};

export const RenderField = ({field, formData, formErrors, handleChange, handleBlur, navigateToStep, formDefinition, formSummaryData}) : JSX.Element => {
  const formDataEntry: FormDataEntry = formData[field["@column"]];
  const errors = formErrors[field["@column"]];

  return (
    <React.Fragment>
      {GetComponent({field: field, formDataEntry: formDataEntry, errors: errors, handleChange: handleChange, handleBlur : handleBlur, formData: formData, formSummaryData: formSummaryData, formDefinition: formDefinition, navigateToStep: navigateToStep})}
      {ValidationErrorsHtml(field["@column"], errors)}
    </React.Fragment>
  );
};

export const RenderStep = ({formDefinition, fields, visibleFields, currentStepIndex, formData, formErrors, handleChange, handleBlur, setFormData, formSummaryData, navigateToStep}) : JSX.Element => {
  const step = formDefinition.form.sections[currentStepIndex];
  const stepFields = step.fields.map(field => {
    return fields.find(f => f["@guid"] === field.identifier);
  })?.filter(Boolean) ?? [];
  const hasRequiredFields = stepFields.some(field => !field["@allowempty"]);

  const renderedFields = step.fields.map(fieldRef => {
    const field = visibleFields.find(f => f["@guid"] === fieldRef.identifier);

    if(!field) {
      return (null);
    }

    const handleChangeFunction = getCustomHandleChange(field, handleChange, formData, setFormData);
    const handleBlurFunction = handleBlur;

    return RenderField({field: field, formData: formData, formErrors: formErrors, handleChange: handleChangeFunction, handleBlur: handleBlurFunction, formDefinition: formDefinition, formSummaryData : formSummaryData, navigateToStep: navigateToStep});
  });

  return (
    <div className="form-section">
      {hasRequiredFields && (
        <p className="form-header__required-tag">{getResourceString("Form.RequiredFieldsHint")}</p>
      )}
      <div className="form-section--fields">
        {renderedFields}
      </div>
    </div>
  );
};

export const getCustomHandleChange = (field: Field, defaultHandleChange: any, formData: any, setFormData: any) => {
  let handleChangeFunction = defaultHandleChange;

  // By inputcontrolstyle
  switch (field.properties.inputcontrolstyle) {
    case 'adreszoeker':
      handleChangeFunction = new AdresZoeker(formData, setFormData).handleAdresZoekerChange;
    default: 
      break;
  }

  // By PicklistMode
  if(field.settings.PicklistMode && field.settings.PicklistMode === 'custompicklist') {
    if(field.settings.PicklistTemplate === 'bedrijvenzoeker') {
      if(field["@column"].endsWith('Naam')) {
        handleChangeFunction = new CompanySearcher(formData, setFormData).handleCompanySearchChange;
      }
      else if(field["@column"].endsWith('Plaats')) {
        handleChangeFunction = new CompanySearcher(formData, setFormData).handleCompanyCityChange;
      }
    }
    else if(field.settings.PicklistTemplate === 'incomeRelationSearcher') {
      if(field["@column"] === 'BedrijfsNaam' ) {
        handleChangeFunction = new IncomeRelationSearcher(formData, setFormData).handleCompanySearchChange;
      }
      if(field["@column"] === 'BedrijfWoonplaats') {
        handleChangeFunction = new IncomeRelationSearcher(formData, setFormData).handleCompanyCityChange;
      }
    }
  }

  return handleChangeFunction;
};